// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-action-btn-wrapper-usr {
    margin-top: 50px;
}


.edit-profile-usr form .error-message {
    color: red;
    margin-top: 5px;
    font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/css/profile.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;;AAGA;IACI,UAAU;IACV,eAAe;IACf,eAAe;AACnB","sourcesContent":[".profile-action-btn-wrapper-usr {\n    margin-top: 50px;\n}\n\n\n.edit-profile-usr form .error-message {\n    color: red;\n    margin-top: 5px;\n    font-size: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
